export const isCCExpired = (mo: number, year: number) => {
    const today = new Date()

    return (
        year < today.getFullYear() ||
        (mo < today.getMonth() + 1 && year <= today.getFullYear())
    )
}
